export * from './PayPalIcon';
export * from './GooglePayIcon';
export * from './AmericanExpressIcon';
export * from './MastercardIcon';
export * from './ApplePayIcon';
export * from './JCBIcon';
export * from './WeChatIcon';
export * from './GiropayIcon';
export * from './NetellerIcon';
export * from './AlipayIcon';
export * from './BitcoinIcon';
export * from './SkrillIcon';
export * from './getIconPayments';
